import type { BackendApi } from '../backend/client'

/**
 * Resolves the signed-in user's organization. Takes no identifiers -- both the
 * user id and email come from the JWT, so a caller can only ever ask about
 * their own organization. `scope: 'membership'` restricts the lookup to an
 * organization the user is already linked to; omit (or `'all'`) to also fall
 * back to an email-domain or promo-code match. See openapi.yaml `getMyOrganization`.
 */
export function getMyOrganization(api: BackendApi, scope?: 'membership' | 'all') {
  return api.getMyOrganization({ scope })
}
